











































import Vue from 'vue';

export default Vue.extend({
  props: {
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    recibos: [],
    headers: [
      { text: 'Propietario', value: 'propietario.nombre' },
      { text: 'Unidad', value: 'unidad.name' },
      // { text: 'Recibo ID', value: 'id' },
      { text: 'Conceptos', value: 'items.length', sortable: false },
      { text: 'Subtotal', value: 'subtotal', sortable: false },
      { text: 'Monto Total', value: 'total', sortable: false },
    ],
    total: 0,
    precision: 2,
  }),
  methods: {
    closeDialog() {
      this.openDialog = false;
    },
    async EliminarBorradores() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      for (const borrador of this.recibos) {
        try {
          const recibo = borrador;
          const datos = {admin, condo, recibo};
          console.log('deleteBorrador datos: %o', datos);
          const response = await this.$store.dispatch('deleteBorrador', {admin, condo, recibo});
          console.log('deleteBorrador response: %o', response);
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
          return;
        }
      }
      this.$toast.success('Borradores eliminados exitosamente');
      this.closeDialog();
      this.$emit('reload', {});
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.recibos = this.recibosInit;
        this.total = this.recibos.length;
      } else {
        this.recibos = [];
      }
    },
  },
});
